import React, { Fragment } from "react";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// Sections for this page
import BackgroundSection from "../components/Section/BackgroundSection";

import styles from "assets/jss/material-dashboard-pro-react/views/website/landingPageStyle";
const useStyles = makeStyles(styles);

export default function LandingPage({ ...rest }) {
  
  const classes = useStyles();
  return (
    <div>
      <BackgroundSection
        {...rest}
        landing
        className={classes.backgroundLanding}
        image={require("assets/img/landing/landing-background.png")} 
        title="Embrace the future of Commercial Real Estate"
        subtitle={<Fragment>The World’s #1 comprehensive suite of products you need to <b>run and transform</b> your business forever. 
        With the <b>Exaspaces Platform</b>, you get the foundation to <b>Streamline, Optimize and 
        Accelerate</b> your business.</Fragment>}
      />
    </div>
  );
}
